module.exports = __webpack_public_path__ + "static/img/2_5_1.952c25c9.jpg";